import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { useGame } from '@domain/game.selection/game.selection.hook';

const columns = [
  { field: 'id', headerName: 'IFlag', width: 120 },
  { field: 'name', headerName: 'Name', width: 200, flex: 0.5 },
  { field: 'value', headerName: 'Value', width: 200, flex: 0.5 },
];

interface IFlagData {
  id: number;
  flag: string;
  value: string;
}

const IFlags = ({ player }: PlayerDataProps) => {
  const game = useGame();
  const { authorizedServices } = useAuth();
  const { pid } = player;

  function getIFlagName(key: string): string {
    const iFlag = game.iFlagsCatalog.find((obj) => obj.key.toString() === key);
    return iFlag ? iFlag.value : key;
  }

  function createData(data: IFlagData) {
    const { flag, value } = data;
    const name = getIFlagName(flag);
    const formattedValue = game.iFlagFormatter(flag, name, value);
    return { id: flag, name, value: formattedValue };
  }

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<IFlagData[]>(`/admin/iflags/player/${requestPid}`, { params: { page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];

  return (
    <TabTableContainer>
      <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
    </TabTableContainer>
  );
};

export default IFlags;
